import {
    DEVELOPER_TOOLS_CAPABILITY,
    EDITORIALDASH_CAPABILITY,
    MODDASHBOARD_CAPABILITY,
    MODERATIONDASH_CAPABILITY,
    SETTINGS_CAPABILITY,
} from 'feature/feature-roles';
import type { AdminConfig } from 'structure/admin';
import type { Feature } from 'util/stdtypes';
import { t } from 'util/stdtypes';

export const AdminModLinkFeature: Feature<AdminConfig, {}> = {
    key: 'admin_link_mod',
    name: 'Legacy Moderation Link',
    providesConfig: {
        quickLinks: [{ label: t('Legacy Moderation Dashboard'), structureKey: 'moderationdash', capability: MODERATIONDASH_CAPABILITY }],
    },
};

export const NewModLinkFeature: Feature<AdminConfig, {}> = {
    key: 'admin_new_link_mod',
    name: 'New Moderation Link',
    providesConfig: {
        quickLinks: [{ label: t('New Moderation Dashboard'), structureKey: 'moddashboard', capability: MODDASHBOARD_CAPABILITY }],
    },
};

export const EditorialDashFeature: Feature<AdminConfig, {}> = {
    key: 'admin_editorial_dash',
    name: 'Editorial Dashboard',
    providesConfig: {
        quickLinks: [{ label: t('Editorial Dashboard'), structureKey: 'editorialdash', capability: EDITORIALDASH_CAPABILITY }],
    },
};

export const SettingsFeature: Feature<AdminConfig, {}> = {
    key: 'admin_settings',
    name: 'Settings',
    providesConfig: {
        quickLinks: [{ label: t('Settings'), structureKey: 'settings', capability: SETTINGS_CAPABILITY }],
    },
};

export const DeveloperToolsFeature: Feature<AdminConfig, {}> = {
    key: 'admin_developer_tools',
    name: 'Developer Tools',
    dev: true,
    providesConfig: {
        quickLinks: [{ label: t('Developer Tools'), structureKey: 'developer-tools', capability: DEVELOPER_TOOLS_CAPABILITY }],
    },
};
